export const textoPeriodoCumple = (periodoMora: string) => {
    const textoEsNumerico = texto => /^\d+$/.test(texto);
    const textoEsMesValido = texto => parseInt(texto.substr(4)) <= 12;

    return textoEsNumerico(periodoMora) && periodoMora.length === 6 && textoEsMesValido(periodoMora);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/FuncionesComunes.ts